import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { convertToSnakeCase } from '../Util/CommonUtils';

// eslint-disable-next-line require-jsdoc
const LearnMoreLink = (props) => {
  const { product } = props;

  const getLinkText = () => {
    return product.LeranMoreOnly
      ? 'Learn more'
      : `Learn more about ${
          product.LearnMoreSuffixText ? product.LearnMoreSuffixText : product.ProductName
        }`;
  };

  const getContent = () => {
    return (
      <p
        className="margin-bottom-20"
        data-ui-object="link"
        data-refer-ui-access-point={`${convertToSnakeCase(getLinkText())} | ${convertToSnakeCase(
          product.LearnMoreLink,
        )}`}
      >
        {getLinkText()}
      </p>
    );
  };

  return (
    <Link
      to={product.LearnMoreLink}
      data-wa-link={`${getLinkText().toLowerCase()}:${product.LearnMoreLink}`}
      className="learn-more"
    >
      {getContent()}
    </Link>
  );
};

LearnMoreLink.propTypes = {
  product: PropTypes.object.isRequired,
};

export default LearnMoreLink;
